export default __webpack_public_path__ + "static/media/v_1.63ce5506.jpg";